<!-- eslint-disable vue/max-attributes-per-line -->
<template>
    <List
        :data="list"
        :has-more="hasMore"
        :empty-content="emptyContent"
        @load-more="handleLoadMore"
        @item-click="handleItemClick"
    />
</template>

<script >
import { computed, onMounted, ref } from 'vue-demi';
import { BIND_STATUS_INVALID, PAGE_SIZE, DEFAULT_OPTION } from '../assets/scripts/constants';
import request from '../assets/scripts/request';
import List from '../components/List.vue';
import { getFissionStatusContent, parseFissionStatusRules } from '../assets/scripts/utils';
const __sfc_main = {};
__sfc_main.props = {
  listTotalParam: {
    type: String,
    default: 'listTotal'
  },
  actSign: {
    type: String,
    default: ''
  },
  module: {
    type: String,
    default: ''
  },
  isPreviewEmpty: {
    type: Boolean,
    default: false
  },
  emptyContent: {
    type: String,
    default: ''
  },
  defaultStatusContent: {
    type: String,
    default: ''
  },
  statusList: {
    type: Array,
    default: () => []
  },
  /** 是否需要 Push 能力（请求携带 actionId） */
  needPush: {
    type: Boolean,
    default: false
  },
  /** 默认 Push 提醒对应的动作 id */
  pushDefaultActionId: {
    type: String,
    default: ''
  },
  /** 仍可发送 Push 时右侧富文本 */
  pushAvailableContent: {
    type: String,
    default: DEFAULT_OPTION.pushAvailableContent
  },
  /** 提醒成功toast */
  pushSuccessToast: {
    type: String,
    default: DEFAULT_OPTION.pushSuccessToast
  },
  /** 发送失败toast */
  pushFailedToast: {
    type: String,
    default: DEFAULT_OPTION.pushFailedToast
  },
  /** 已提醒点击toast */
  pushedToast: {
    type: String,
    default: DEFAULT_OPTION.pushedToast
  },
  /** 不可发送 Push 时右侧富文本 */
  pushUnavailableContent: {
    type: String,
    default: DEFAULT_OPTION.pushUnavailableContent
  },
  /** 是否拉取含已失效记录并展示过期文案 */
  showExpired: {
    type: Boolean,
    default: false
  },
  /** 已失效（过期）行右侧富文本 */
  expiredStateContent: {
    type: String,
    default: DEFAULT_OPTION.expiredStateContent
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    store: {
      variable
    }
  } = require('@futuweb/fego-render');
  const {
    useToast
  } = require('@fegobull/webapi').use;
  const Toast = useToast();
  const props = __props;
  const hasMore = ref(false);
  const list = ref([]);
  const page = ref(1);
  const sendingRemind = ref(false);
  const statusRules = computed(() => parseFissionStatusRules(props.statusList));
  const pushDisplayConfig = computed(() => ({
    showExpired: props.showExpired,
    expiredStateContent: props.expiredStateContent,
    needPush: props.needPush,
    pushDefaultActionId: props.pushDefaultActionId,
    pushAvailableContent: props.pushAvailableContent,
    pushUnavailableContent: props.pushUnavailableContent
  }));

  // 更新fego变量
  const updateFegoVariable = (key, value) => {
    variable.data[key] = value;
  };
  const getStatusContent = item => {
    return getFissionStatusContent({
      item,
      rules: statusRules.value,
      config: pushDisplayConfig.value,
      defaultStatusContent: props.defaultStatusContent
    });
  };
  const getList = async () => {
    try {
      Toast.loading();
      const params = {
        actSign: props.actSign,
        module: props.module,
        page: page.value,
        pageSize: PAGE_SIZE
      };
      const actionId = Number(props.pushDefaultActionId);
      if (props.needPush && actionId) {
        params.pushActionId = actionId;
      }
      if (props.showExpired) {
        params.showExpired = true;
      }
      const res = await request.getFissionList(params);
      updateFegoVariable(props.listTotalParam, res.total);
      const reslist = res.list.map(item => {
        const statusContent = getStatusContent(item);
        return {
          ...item,
          content: statusContent.content,
          styleType: statusContent.styleType
        };
      });
      hasMore.value = res.page * res.pageSize < res.total;
      if (hasMore.value) {
        page.value += 1;
      }
      list.value = [...list.value, ...reslist];
    } catch (error) {
      console.error('加载数据失败:', error);
    } finally {
      Toast.close();
    }
  };
  const handleLoadMore = async callback => {
    if (!hasMore.value) {
      callback?.();
      return;
    }
    await getList();
    callback?.();
  };
  const showToast = message => {
    if (!message) {
      return;
    }
    const options = {
      message,
      zIndex: 9999
    };
    Toast.msg(options);
  };

  /**
   * 点击行右侧内容：仅在开启 Push 且非过期、可提醒时，以当前行 tarUid 作为 pushUid 调用提醒接口
   */
  const handleItemClick = async item => {
    if (!props.needPush || sendingRemind.value) {
      return;
    }
    if (item.bindStatus === BIND_STATUS_INVALID) {
      return;
    }
    if (item.canRemind !== true) {
      showToast(props.pushedToast);
      return;
    }
    const actionId = Number(props.pushDefaultActionId);
    if (actionId <= 0) {
      return;
    }
    const pushUid = Number(item.tarUid);
    if (!pushUid) {
      return;
    }
    sendingRemind.value = true;
    try {
      await request.remindInvitee({
        actSign: props.actSign,
        module: props.module,
        pushActionId: actionId,
        pushUid
      });
      showToast(props.pushSuccessToast);
      // 更新当前行状态与展示文案
      item.canRemind = false;
      const statusContent = getStatusContent(item);
      item.content = statusContent.content;
      item.styleType = statusContent.styleType;
    } catch (err) {
      console.error('remindInvitee 失败:', err);
      showToast(props.pushFailedToast);
    } finally {
      sendingRemind.value = false;
    }
  };
  onMounted(() => {
    getList();
  });
  return {
    hasMore,
    list,
    handleLoadMore,
    handleItemClick
  };
};
__sfc_main.components = Object.assign({
  List
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped></style>
